var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isAvailableItemsActive && _vm.avaliableItemsType === "PARTS"
        ? _c("available-parts", {
            attrs: {
              "quote-id": _vm.value.quoteId,
              "quote-no": _vm.value.quoteNo,
              "sub-quote-no": _vm.value.subQuoteNo,
              "page-size": 1200,
              "sub-quote-nos": _vm.value.subQuoteNos,
              "is-audanet": _vm.value.audatex !== null,
              "next-line-number": _vm.nextLineNumber,
              "show-scroll-to-add": false,
              "vehicle-id": _vm.vehicle ? _vm.vehicle.id : "",
              "selected-sub-sections": _vm.selectedSubSections,
              "selected-area": _vm.selectedArea,
            },
            on: { "item-added": _vm.onItemAddedPart },
            model: {
              value: _vm.innerValue.parts,
              callback: function ($$v) {
                _vm.$set(_vm.innerValue, "parts", $$v)
              },
              expression: "innerValue.parts",
            },
          })
        : _vm._e(),
      _vm.isMainActive && _vm.avaliableItemsType === "PARTS"
        ? _c("available-parts-main", {
            attrs: {
              "quote-id": _vm.value.quoteId,
              "quote-no": _vm.value.quoteNo,
              "page-size": 1200,
              "sub-quote-no": _vm.value.subQuoteNo,
              "next-line-number": _vm.nextLineNumber,
              "selected-sub-sections": _vm.selectedSubSections,
              "selected-area": _vm.selectedArea,
            },
            on: { "item-added": _vm.onItemAddedPart },
            model: {
              value: _vm.innerValue.parts,
              callback: function ($$v) {
                _vm.$set(_vm.innerValue, "parts", $$v)
              },
              expression: "innerValue.parts",
            },
          })
        : _vm._e(),
      _vm.isAvailableItemsActive &&
      _vm.avaliableItemsType === "LABOUR" &&
      !_vm.isSundry
        ? _c("available-labours", {
            attrs: {
              "quote-id": _vm.value.quoteId,
              "next-line-number": _vm.nextLineNumber,
              "is-audanet": _vm.value.audatex !== null,
              "rr-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.RR,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "rwa-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.RWA,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "repair-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.REP,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "paint-rate": _vm.findLabourRate(
                _vm.vehicle.paintGroup,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "shop-rate": _vm.value.shopRate,
              "vehicle-paint-group": _vm.vehicle.paintGroup,
              "quoting-method": _vm.value.quotingMethod,
              "page-size": 1200,
              "schedule-id": _vm.vehicle.scheduleId,
              "body-id": _vm.vehicle.bodyId,
              make: _vm.vehicle.model.make,
              model: _vm.vehicle.model.model,
              year: _vm.vehicleBuildYear,
              "labour-type": _vm.value.labourType,
              "is-ntar": _vm.isNtar,
              "show-scroll-on-add": false,
              "selected-sub-sections": _vm.selectedSubSections,
              "selected-area": _vm.selectedArea,
            },
            on: { "item-added": _vm.onItemAddedLabour },
            model: {
              value: _vm.innerValue.labours,
              callback: function ($$v) {
                _vm.$set(_vm.innerValue, "labours", $$v)
              },
              expression: "innerValue.labours",
            },
          })
        : _vm._e(),
      _vm.isAvailableItemsActive &&
      _vm.avaliableItemsType === "LABOUR" &&
      !!_vm.isSundry
        ? _c(
            "div",
            [
              _c("available-labour-sundry", {
                attrs: {
                  "shop-rate": _vm.value.shopRate,
                  "next-line-number": _vm.nextLineNumber,
                  "vehicle-paint-group": _vm.vehicle.paintGroup,
                  "quoting-method": _vm.value.quotingMethod,
                  "selected-area": _vm.selectedArea,
                },
                on: { "item-added": _vm.onItemAddedLabour },
                model: {
                  value: _vm.innerValue.labours,
                  callback: function ($$v) {
                    _vm.$set(_vm.innerValue, "labours", $$v)
                  },
                  expression: "innerValue.labours",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.isMainActive && _vm.avaliableItemsType === "LABOUR"
        ? _c("available-labours-main", {
            attrs: {
              "quote-id": _vm.value.quoteId,
              "next-line-number": _vm.nextLineNumber,
              "quote-no": _vm.value.quoteNo,
              "sub-quote-no": _vm.value.subQuoteNo,
              "rr-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.RR,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "rwa-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.RWA,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "repair-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.REP,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "paint-rate": _vm.findLabourRate(
                _vm.vehicle.paintGroup,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "vehicle-paint-group": _vm.vehicle.paintGroup,
              "quoting-method": _vm.value.quotingMethod,
              "page-size": 1200,
              "schedule-id": _vm.vehicle.scheduleId,
              "body-id": _vm.vehicle.bodyId,
              make: _vm.vehicle.model.make,
              model: _vm.vehicle.model.model,
              year: _vm.vehicleBuildYear,
              "labour-type": _vm.innerValue.labourType,
              "selected-area": _vm.selectedArea,
            },
            on: { "item-added": _vm.onItemAddedLabour },
            model: {
              value: _vm.innerValue.labours,
              callback: function ($$v) {
                _vm.$set(_vm.innerValue, "labours", $$v)
              },
              expression: "innerValue.labours",
            },
          })
        : _vm._e(),
      _vm.isAvailableItemsActive &&
      _vm.avaliableItemsType === "OTHER" &&
      !_vm.isLabourOtherNtar
        ? _c("available-other-labours", {
            attrs: {
              "quote-id": _vm.value.quoteId,
              "next-line-number": _vm.nextLineNumber,
              "is-audanet": _vm.value.audatex !== null,
              "quoting-method": _vm.value.quotingMethod,
              "page-size": 1200,
              "fg-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.FIBER,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "crush-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.CRUSH,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "cd-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.CD,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "mech-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.MECH,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "shop-rate": _vm.value.shopRate,
              "is-ntar": _vm.isNtar,
              "selected-area": _vm.selectedArea,
            },
            on: { "item-added": _vm.onItemAddedOther },
            model: {
              value: _vm.innerValue.others,
              callback: function ($$v) {
                _vm.$set(_vm.innerValue, "others", $$v)
              },
              expression: "innerValue.others",
            },
          })
        : _vm._e(),
      _vm.isAvailableItemsActive &&
      _vm.avaliableItemsType === "OTHER" &&
      _vm.isNtar &&
      !!_vm.isLabourOtherNtar
        ? _c("available-other-labours-ntar", {
            attrs: {
              "quote-id": _vm.value.quoteId,
              "next-line-number": _vm.nextLineNumber,
              "is-audanet": _vm.value.audatex !== null,
              "quoting-method": _vm.value.quotingMethod,
              "page-size": 1200,
              "fg-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.FIBER,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "crush-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.CRUSH,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "cd-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.CD,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "mech-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.MECH,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "shop-rate": _vm.value.shopRate,
              "is-ntar": _vm.isNtar,
              "selected-area": _vm.selectedArea,
            },
            on: { "item-added": _vm.onItemAddedOther },
            model: {
              value: _vm.innerValue.others,
              callback: function ($$v) {
                _vm.$set(_vm.innerValue, "others", $$v)
              },
              expression: "innerValue.others",
            },
          })
        : _vm._e(),
      _vm.isMainActive && _vm.avaliableItemsType === "OTHER"
        ? _c("available-other-labours-main", {
            attrs: {
              "quote-id": _vm.value.quoteId,
              "quote-no": _vm.value.quoteNo,
              "sub-quote-no": _vm.value.subQuoteNo,
              "next-line-number": _vm.nextLineNumber,
              "quoting-method": _vm.value.quotingMethod,
              "page-size": 1200,
              "fg-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.FIBER,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "crush-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.CRUSH,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "cd-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.CD,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "mech-rate": _vm.findLabourRate(
                _vm.itemCategoryTypes.MECH,
                _vm.innerValue.rates,
                _vm.innerValue.shopRate,
                _vm.innerValue.quoteId
              ).rate,
              "selected-area": _vm.selectedArea,
            },
            on: { "item-added": _vm.onItemAddedOther },
            model: {
              value: _vm.innerValue.others,
              callback: function ($$v) {
                _vm.$set(_vm.innerValue, "others", $$v)
              },
              expression: "innerValue.others",
            },
          })
        : _vm._e(),
      _vm.isAvailableItemsActive && _vm.avaliableItemsType === "MISC"
        ? _c("available-miscs", {
            attrs: {
              "quote-id": _vm.value.quoteId,
              "labour-type": _vm.value.labourType,
              "next-line-number": _vm.nextLineNumber,
              "is-audanet": _vm.value.audatex !== null,
              "is-ntar": _vm.isNtar,
              "page-size": 1200,
              "selected-area": _vm.selectedArea,
            },
            on: { "item-added": _vm.onItemAddedMisc },
            model: {
              value: _vm.innerValue.miscs,
              callback: function ($$v) {
                _vm.$set(_vm.innerValue, "miscs", $$v)
              },
              expression: "innerValue.miscs",
            },
          })
        : _vm._e(),
      _vm.isMainActive && _vm.avaliableItemsType === "MISC"
        ? _c("available-miscs-main", {
            attrs: {
              "quote-id": _vm.value.quoteId,
              "quote-no": _vm.value.quoteNo,
              "sub-quote-no": _vm.value.subQuoteNo,
              "labour-type": _vm.value.labourType,
              "next-line-number": _vm.nextLineNumber,
              "page-size": 1200,
              "selected-area": _vm.selectedArea,
            },
            on: { "item-added": _vm.onItemAddedMisc },
            model: {
              value: _vm.innerValue.miscs,
              callback: function ($$v) {
                _vm.$set(_vm.innerValue, "miscs", $$v)
              },
              expression: "innerValue.miscs",
            },
          })
        : _vm._e(),
      _vm.isAvailableItemsActive && _vm.avaliableItemsType === "SUBLETS"
        ? _c("available-sublets", {
            attrs: {
              "quote-id": _vm.value.quoteId,
              "labour-type": _vm.value.labourType,
              "next-line-number": _vm.nextLineNumber,
              "is-audanet": _vm.value.audatex !== null,
              "page-size": 1200,
              "selected-area": _vm.selectedArea,
            },
            on: { "item-added": _vm.onItemAddedSublet },
            model: {
              value: _vm.innerValue.sublets,
              callback: function ($$v) {
                _vm.$set(_vm.innerValue, "sublets", $$v)
              },
              expression: "innerValue.sublets",
            },
          })
        : _vm._e(),
      _vm.isMainActive && _vm.avaliableItemsType === "SUBLETS"
        ? _c("available-sublets-main", {
            attrs: {
              "quote-id": _vm.value.quoteId,
              "quote-no": _vm.value.quoteNo,
              "sub-quote-no": _vm.value.subQuoteNo,
              "labour-type": _vm.value.labourType,
              "next-line-number": _vm.nextLineNumber,
              "page-size": 1200,
              "selected-area": _vm.selectedArea,
            },
            on: { "item-added": _vm.onItemAddedSublet },
            model: {
              value: _vm.innerValue.sublets,
              callback: function ($$v) {
                _vm.$set(_vm.innerValue, "sublets", $$v)
              },
              expression: "innerValue.sublets",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }